export enum airplaneStates {
  READY_TO_FLY = 'readyToFly',
  FLYING = 'flying',
  FLEW_AWAY = 'flewAway',
}
